import axios from 'axios'
import cookie from './cookie.js'

// The server CSRF pair is session-bound — a cached token goes stale after every bridge login.

let bootstrap = null

export const ensureFreshCsrf = () => {
  if (!bootstrap) {
    bootstrap = axios.get(`${location.origin}/api/csrf-token`, { withCredentials: true })
      .then((res) => {
        cookie.set('csrfCookie', res.data.csrfToken, 1)
      })
      .catch((err) => {
        // Allow a later retry instead of caching the failure forever.
        bootstrap = null
        throw err
      })
  }
  return bootstrap
}

export const refreshCsrf = () => {
  bootstrap = null
  cookie.set('csrfCookie', 0, -1)
  return ensureFreshCsrf()
}
